/**
 * Time on page for the admin Usage page; signed-in routes only.
 *
 * A component that renders nothing, like `<ScrollToTop>`, rather than a hook
 * the shell calls: tracking reads the location, and whatever reads it
 * re-renders on every navigation. Here that is this empty component, not the
 * header, footer and outlet around it.
 */

import { usePageTimeTracking } from "@/hooks";

export function PageTimeTracker() {
  usePageTimeTracking();
  return null;
}
